import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import mixins from "@/assets/functions.js"
import * as firebase from "firebase";

Vue.config.productionTip = false
const firebaseConfig = {
  apiKey: "AIzaSyA-1sCciL8VSnEw2lhNNumfZubuJvILmTc",
  authDomain: "checkit-now.firebaseapp.com",
  databaseURL: "https://checkit-now.firebaseio.com",
  projectId: "checkit-now",
  storageBucket: "checkit-now.appspot.com",
  messagingSenderId: "554916903401",
  appId: "1:554916903401:web:4b83253698f4884bc5b378",
  measurementId: "G-H1VQ1XDKNC"
};


import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
  moment,
})
Vue.mixin({
  methods: mixins
})
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
